module.exports = __webpack_public_path__ + "static/media/not_allowed.9af2c822.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/not_allowed.svg
// module id = 518
// module chunks = 0